import { React, useEffect, useState } from 'libs/react';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { DealPresentationSection } from './DealPresentationSection';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { Text } from 'components/Text';
import './DealPresentationPanel.scss';
/**
 * @component DealPresentationPanel
 * @since 1.0.0
 */
export function DealPresentationPanel(props) {
    var _a, _b, _c, _d, _e, _f;
    const { deal } = props;
    const { configurationFields } = useDealConfiguratorContext();
    /**
     * Headline
     */
    const [headline] = useState((_c = (_b = (_a = deal.translations) === null || _a === void 0 ? void 0 : _a.find((translation) => translation.language.code === deal.language)) === null || _b === void 0 ? void 0 : _b.headline) !== null && _c !== void 0 ? _c : getConfigurationFieldValue(configurationFields, 'HEADLINE'));
    const [defaultHeaderImage] = useState(getConfigurationFieldValue(configurationFields, 'DEFAULT_HEADER_IMAGE'));
    const [defaultHeaderVideo] = useState(getConfigurationFieldValue(configurationFields, 'DEFAULT_HEADER_VIDEO'));
    const [headerMediaType, setHeaderImageType] = useState(() => {
        var _a, _b;
        if ((_a = deal.medias) === null || _a === void 0 ? void 0 : _a.some((media) => media.type === 'HEADER_IMAGE')) {
            return 'image';
        }
        else if ((_b = deal.medias) === null || _b === void 0 ? void 0 : _b.some((media) => media.type === 'HEADER_VIDEO')) {
            return 'video';
        }
        else if (defaultHeaderVideo) {
            return 'video';
        }
        else {
            return 'default';
        }
    });
    const [headerMediaValue, setHeaderMediaValue] = useState(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if ((_a = deal.medias) === null || _a === void 0 ? void 0 : _a.some((media) => media.type === 'HEADER_IMAGE')) {
            return ((_e = (_d = (_c = (_b = deal.medias) === null || _b === void 0 ? void 0 : _b.find((media) => media.type === 'HEADER_IMAGE')) === null || _c === void 0 ? void 0 : _c.media) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '');
        }
        else if ((_f = deal.medias) === null || _f === void 0 ? void 0 : _f.some((media) => media.type === 'HEADER_VIDEO')) {
            return ((_j = (_h = (_g = deal.medias) === null || _g === void 0 ? void 0 : _g.find((media) => media.type === 'HEADER_VIDEO')) === null || _h === void 0 ? void 0 : _h.url) !== null && _j !== void 0 ? _j : '');
        }
        else if (defaultHeaderVideo) {
            return defaultHeaderVideo;
        }
        else {
            return defaultHeaderImage;
        }
    });
    /**
     * Introduction
     */
    const [introduction] = useState((_f = (_e = (_d = deal.translations) === null || _d === void 0 ? void 0 : _d.find((translation) => translation.language.code === deal.language)) === null || _e === void 0 ? void 0 : _e.introduction) !== null && _f !== void 0 ? _f : getConfigurationFieldValue(configurationFields, 'INTRODUCTION'));
    const [defaultIntroductionImage] = useState(getConfigurationFieldValue(configurationFields, 'DEFAULT_INTRODUCTION_IMAGE'));
    const [defaultIntroductionVideo] = useState(getConfigurationFieldValue(configurationFields, 'DEFAULT_INTRODUCTION_VIDEO'));
    const [introductionMediaType, setIntroductionImageType] = useState(() => {
        var _a, _b;
        if ((_a = deal.medias) === null || _a === void 0 ? void 0 : _a.some((media) => media.type === 'INTRODUCTION_IMAGE')) {
            return 'image';
        }
        else if ((_b = deal.medias) === null || _b === void 0 ? void 0 : _b.some((media) => media.type === 'INTRODUCTION_VIDEO')) {
            return 'video';
        }
        else if (defaultIntroductionVideo) {
            return 'video';
        }
        else {
            return 'default';
        }
    });
    const [introductionMediaValue, setIntroductionMediaValue] = useState(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if ((_a = deal.medias) === null || _a === void 0 ? void 0 : _a.some((media) => media.type === 'INTRODUCTION_IMAGE')) {
            return ((_e = (_d = (_c = (_b = deal.medias) === null || _b === void 0 ? void 0 : _b.find((media) => media.type === 'INTRODUCTION_IMAGE')) === null || _c === void 0 ? void 0 : _c.media) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '');
        }
        else if ((_f = deal.medias) === null || _f === void 0 ? void 0 : _f.some((media) => media.type === 'INTRODUCTION_VIDEO')) {
            return ((_j = (_h = (_g = deal.medias) === null || _g === void 0 ? void 0 : _g.find((media) => media.type === 'INTRODUCTION_VIDEO')) === null || _h === void 0 ? void 0 : _h.url) !== null && _j !== void 0 ? _j : '');
        }
        else if (defaultIntroductionVideo) {
            return defaultIntroductionVideo;
        }
        else {
            return defaultIntroductionImage;
        }
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if ((_a = deal.medias) === null || _a === void 0 ? void 0 : _a.some((media) => media.type === 'HEADER_IMAGE')) {
            setHeaderMediaValue((_e = (_d = (_c = (_b = deal.medias) === null || _b === void 0 ? void 0 : _b.find((media) => media.type === 'HEADER_IMAGE')) === null || _c === void 0 ? void 0 : _c.media) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '');
            setHeaderImageType('image');
        }
        else if ((_f = deal.medias) === null || _f === void 0 ? void 0 : _f.some((media) => media.type === 'HEADER_VIDEO')) {
            setHeaderMediaValue((_j = (_h = (_g = deal.medias) === null || _g === void 0 ? void 0 : _g.find((media) => media.type === 'HEADER_VIDEO')) === null || _h === void 0 ? void 0 : _h.url) !== null && _j !== void 0 ? _j : '');
            setHeaderImageType('video');
        }
        else if (defaultHeaderVideo) {
            setHeaderMediaValue(defaultHeaderVideo);
            setHeaderImageType('video');
        }
        else {
            setHeaderMediaValue(defaultHeaderImage);
            setHeaderImageType('default');
        }
        if ((_k = deal.medias) === null || _k === void 0 ? void 0 : _k.some((media) => media.type === 'INTRODUCTION_IMAGE')) {
            setIntroductionMediaValue((_p = (_o = (_m = (_l = deal.medias) === null || _l === void 0 ? void 0 : _l.find((media) => media.type === 'INTRODUCTION_IMAGE')) === null || _m === void 0 ? void 0 : _m.media) === null || _o === void 0 ? void 0 : _o.id) !== null && _p !== void 0 ? _p : '');
            setIntroductionImageType('image');
        }
        else if ((_q = deal.medias) === null || _q === void 0 ? void 0 : _q.some((media) => media.type === 'INTRODUCTION_VIDEO')) {
            setIntroductionMediaValue((_t = (_s = (_r = deal.medias) === null || _r === void 0 ? void 0 : _r.find((media) => media.type === 'INTRODUCTION_VIDEO')) === null || _s === void 0 ? void 0 : _s.url) !== null && _t !== void 0 ? _t : '');
            setIntroductionImageType('video');
        }
        else if (defaultIntroductionVideo) {
            setIntroductionMediaValue(defaultIntroductionVideo);
            setIntroductionImageType('video');
        }
        else {
            setIntroductionMediaValue(defaultIntroductionImage);
            setIntroductionImageType('default');
        }
    }, [
        deal,
        defaultHeaderVideo,
        defaultHeaderImage,
        defaultIntroductionVideo,
        defaultIntroductionImage
    ]);
    return (React.createElement("div", { className: "deal-presentation-panel" },
        React.createElement(Text, { className: "deal-settings-panel-title", value: t('Header') }),
        React.createElement(DealPresentationSection, { text: headline, type: "HEADER", media: headerMediaValue, defaultMedia: defaultHeaderVideo || defaultHeaderImage, defaultMediaType: defaultHeaderVideo ? 'video' : 'image', mediaType: headerMediaType, medias: deal.medias }),
        React.createElement(Text, { className: "deal-settings-panel-title", value: t('Introduction') }),
        React.createElement(DealPresentationSection, { text: introduction, type: "INTRODUCTION", media: introductionMediaValue, defaultMedia: defaultIntroductionVideo || defaultIntroductionImage, defaultMediaType: defaultIntroductionVideo ? 'video' : 'image', mediaType: introductionMediaType, medias: deal.medias })));
}
